import React from 'react';
import Button from './Button';
import Modal from './Modal';
import './DeleteConfirmModal.scss';

const DeleteConfirmModal = ({
  isOpen,
  title, // "프로젝트 삭제", "연구 삭제", "산출물 삭제"
  itemName, // 삭제할 항목의 이름
  warningMessage, // 선택적: 추가 경고 메시지 (예: "X개의 조사 포함")
  warningItems, // 선택적: 경고 아이템 리스트 (예: ["3개의 조사", "모든 계획서", ...])
  onConfirm,
  onCancel,
  confirmText = "삭제",
  cancelText = "취소",
  isConfirming = false,
  mainText,
  footerText = "이 작업은 되돌릴 수 없습니다.",
  warningTitle = "주의: 삭제된 데이터는 복구할 수 없습니다.",
  confirmingText,
  className = '',
}) => {
  if (!isOpen) return null;

  // title에서 항목 타입 판별
  const getItemTypeSuffix = () => {
    if (title.includes('프로젝트')) return '프로젝트를';
    if (title.includes('연구')) return '연구를';
    if (title.includes('폴더')) return '폴더를';
    if (title.includes('산출물')) return '산출물을';
    return '을(를)';
  };

  const isFolderDelete = title.includes('폴더');

  return (
    <Modal
      isOpen={isOpen}
      title={title}
      size="sm"
      className={['delete-confirm-modal', className].filter(Boolean).join(' ')}
      bodyClassName="delete-modal-body"
      footerClassName="delete-modal-footer"
      onClose={onCancel}
      closeDisabled={isConfirming}
      showClose={false}
      footer={(
        <>
          <Button
            variant="secondary"
            onClick={onCancel}
            disabled={isConfirming}
          >
            {cancelText}
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={isConfirming}
          >
            {isConfirming ? (confirmingText || `${confirmText} 중...`) : confirmText}
          </Button>
        </>
      )}
    >
      <p className="delete-modal-main-text">
        {mainText || (
          <>
            <strong>"{itemName}"</strong>{' '}
            {isFolderDelete
              ? '폴더를 영구 삭제하시겠습니까?'
              : `${getItemTypeSuffix()} 삭제하시겠습니까?`}
          </>
        )}
      </p>

      {(warningMessage || warningItems) && (
        <div className="delete-modal-warning">
          <p className="delete-modal-warning-title">
            {warningTitle}
          </p>
          {warningItems && warningItems.length > 0 ? (
            <p className="delete-modal-warning-items">
              {warningItems.map((item, index) => (
                <React.Fragment key={index}>
                  • {item}
                  {index < warningItems.length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
          ) : (
            <p className="delete-modal-warning-text">{warningMessage}</p>
          )}
        </div>
      )}

      <p className="delete-modal-footer-text">
        {footerText}
      </p>
    </Modal>
  );
};

export default DeleteConfirmModal;
